export default __webpack_public_path__ + "static/media/reg-designathon.99f9ec46.svg";